import { getAccountId } from '../api/distUI';

let customerIdCache;
const waitForAccountId = async () => {
  customerIdCache = customerIdCache || (await getAccountId());
};

waitForAccountId();

export const transformCustomerInfo = (billingInfo, currency) => {
  const { customer_info: customerInfo, overview } = billingInfo;

  return {
    customerId: customerIdCache,
    userUuid: null,
    firstname: customerInfo.first_name,
    lastname: customerInfo.last_name,
    companyname: customerInfo.company_name,
    email: customerInfo.email,
    phone: customerInfo.phone,
    address1: customerInfo.address1,
    address2: customerInfo.address2,
    city: customerInfo.city,
    state: customerInfo.state,
    country: customerInfo.country,
    zipcode: customerInfo.postal_code4
      ? `${customerInfo.postal_code}-${customerInfo.postal_code4}`
      : customerInfo.postal_code,
    contactEmail: overview.account_email_addresses.contact_email_address,
    vatNumber: customerInfo.non_us_tax_exemption_number || '',
    billingType: {
      name: 'R', // ??
    },
    customerInSingleBilling: false,
    billingLetterOption: customerInfo.billing_letter_option || 'Y',
    currencyCd: currency || 'USD',
    billingPeriod: overview.payment_period,
    billingDayOfMonth: 0,
    addressValidationRequired: true,
    noPrepayAutoRenewOptin: 0,
    addressProvided: true,
    singleBilledAccount: false,
    partnerBilledAccount: false,
    daysLeftInBillingPeriod: overview.days_left_in_period,
    accountStatus: overview.account_status,
    nextChargeScheduled: overview.next_charge_scheduled,
  };
};
